















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { AdminInvoiceRoute } from '@/modules/invoice/routes/admin-invoice.route'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import {
  CampaignItemPaymentCollectionModelInAdmin,
  CampaignItemPaymentCollectionWithModel
} from '@/modules/campaign-item-payment/models/campaign-item-payment-collection.model'
import AdminCampaignItemPaymentItemInfoDialog
  from '@/modules/campaign-item-payment/components/admin/AdminCampaignItemPaymentItemInfoDialog.vue'

@Component({
  components: {
    BaseButton,
    ActionShowButton
  }
})
export default class AdminCampaignItemPaymentActions extends Vue {
  constructor(
    private readonly routes: AdminInvoiceRoute
  ) {
    super()
  }

  @Prop() payment!: CampaignItemPaymentCollectionModelInAdmin
  @Prop() withData!: CampaignItemPaymentCollectionWithModel

  dialogShow() {
    this.$q.dialog({
      component: AdminCampaignItemPaymentItemInfoDialog,
      payment: this.payment,
      withData: this.withData
    })
  }
}

